<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M21.5 3h-19v15h7v4l5.483-4H21.5V3zM7 8.5h10m-10 4h6"/>
</svg>
